const styles = (theme) => ({
  paperAnchor: {
    position: 'absolute',
    width: 400,
    zIndex: 10,
    backgroundColor: theme.ModalBGColor
  }
});

export default styles;
